import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PatientMedication, PatientAllMedicationList } from '../../models/patient-facesheet/patient-medication.model';
import { HttpBaseService } from '../http-base.service';

@Injectable()
export class PatientMedicationService {
  public apiURL = '';
  dataChange: BehaviorSubject<PatientAllMedicationList> = new BehaviorSubject<PatientAllMedicationList>(new PatientAllMedicationList());
  // Temporarily stores data from dialogs
  dialogData: any;
  constructor(private httpClient: HttpClient, private httpService: HttpBaseService) { }

  get data(): PatientAllMedicationList {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  /** CRUD METHODS */
  getAllPatientMedicationHistorys(): void {
    this.httpClient.get<PatientAllMedicationList>(this.apiURL + "patientmedication/PatientAllMedicationList").subscribe(
      data => {
        this.dataChange.next(data);
      },
      (error: HttpErrorResponse) => {
        console.log(error.name + ' ' + error.message);
      }
    );
  }

  addPatientMedication(patientMedication: PatientMedication): void {
    this.dialogData = patientMedication;
    this.getAPIURL();
    this.httpService.post(this.apiURL + "patientmedication/Create", patientMedication, true).subscribe(response => {
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        return false;
      }
    });
  }

  getAPIURL(): void {
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
    });
  }

  updatePatientMedication(patientMedication: PatientMedication): void {
    this.dialogData = patientMedication;
    this.getAPIURL();
    this.httpService.post(this.apiURL + "patientmedication/Edit", patientMedication, true).subscribe(response => {
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        return false;
      }
    });
  }

  deletePatientMedication(id: number): void {
    console.log(id);
  }
}

